import {Injectable} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Cart} from '@spartacus/cart/base/root';
import {CxEvent, EventService} from '@spartacus/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {DcpActiveCartService} from '../../dcp-active-cart.service';
import {DcpDataService} from '../dcp-data.service';
import {DcpEddlCartStateService} from './dcp-eddl-cart-state.service';
import {EddlRemoveFromCartEvent} from './events/eddl-remove-from-cart-event';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpEddlRemoveFromCartService extends DcpDataService<EddlAdobeTrackingData> {
  constructor(protected eventService: EventService,
              protected eddlCartStateService: DcpEddlCartStateService,
              protected activeCartService: DcpActiveCartService) {
    super();
  }

  fillData(event: EddlRemoveFromCartEvent, data?: EddlAdobeTrackingData): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }
    if (!data.ecommerce) {
      data.ecommerce = {};
    }
    if (!data.ecommerce.cart) {
      data.ecommerce.cart = {};
    }
    if (!data.ecommerce.products) {
      data.ecommerce.products = [];
    }
    data.event = 'cartRemove';
    data.ecommerce.cart.id = event.cart.guid;
    data.ecommerce.cart.currency = event.cart.totalPrice?.currencyIso;
    data.ecommerce.products.push(this.eddlCartStateService.getProductTrackingData(event.entry));
    return data;
  }

  getData(event: CxEvent): Observable<EddlAdobeTrackingData> {
    if (!(event instanceof EddlRemoveFromCartEvent)) {
      return undefined;
    }

    return this.activeCartService.getActiveCart().pipe(untilDestroyed(this), map(cart => {
        if (event.productCode) {
          // CPS Product case
          const groups = this.eddlCartStateService.getRelevantCpsGroups((cart as Cart).entryGroups, event.productCode);
          // expected only one entry in the single group
          event.entry = groups?.[0]?.entries?.[0];
        }

        event.cart = cart as Cart;
        return this.fillData(event);
      })
    );
  }
}
